import React, { ReactNode } from "react";
import { cn } from "@/libs/utils";
import { Skeleton } from "@/v2-components/ui/skeleton";

export const SearchPreviewLayoutWebView = ({
  header,
  className,
  isLoading = false,
  children,
}: {
  header: ReactNode;
  className?: string;
  isLoading?: boolean;
} & React.PropsWithChildren) => (
  <section className={cn("flex flex-col gap-4 text-lg font-500", className)}>
    <div>{header}</div>
    {isLoading ? <PreviewSkeleton /> : children}
  </section>
);

const PreviewSkeleton = ({ count = 4 }: { count?: number }) => {
  return (
    <section className="grid grid-cols-2 gap-2">
      {Array.from({ length: count }).map((_, idx) => (
        <div key={idx} className="flex gap-[6px]">
          <Skeleton className="h-[59px] w-[40px] flex-shrink-0 rounded-md" />
          <div className="flex flex-col justify-center gap-1">
            <Skeleton className="h-[14px] w-[80px] rounded-sm" />
          </div>
        </div>
      ))}
    </section>
  );
};
